// src/store/features/message/messageSelectors.js:

import { createSelector } from "reselect";

// Core Selectors
export const selectAllChats = (state) => state?.messages?.chats || [];

export const selectRecentChatIds = (state) =>
  state?.messages?.recentChats || [];

export const selectFetchHistory = (state) =>
  state?.messages?.fetchHistory || [];

export const selectSelectedChatId = (state) => state?.messages?.selectedChatId;

// 🔁 Find chat object by ID from chats array
export const selectChatById = (state, chatId) => {
  return state?.messages?.chats?.find((c) => c.chatId === chatId) || null;
};

export const selectMessagesByChatId = (state, chatId) => {
  return (
    state?.messages?.chats?.find((c) => c.chatId === chatId)?.chatList || []
  );
};

// Derived Selectors
export const selectCurrentChat = createSelector(
  [selectSelectedChatId, selectAllChats],
  (selectedChatId, chats) =>
    chats.find((c) => c.chatId === selectedChatId) || null
);

export const selectCurrentChatMessages = createSelector(
  [selectSelectedChatId, selectAllChats],
  (selectedChatId, chats) =>
    chats.find((c) => c.chatId === selectedChatId)?.chatList || []
);

export const selectIsChatFromRecentChats = (chatId) =>
  createSelector([selectRecentChatIds], (recentChats) =>
    recentChats.includes(chatId)
  );

export const selectIsNewChat = createSelector(
  [selectSelectedChatId, selectAllChats],
  (selectedChatId, chats) => {
    const messages =
      chats.find((c) => c.chatId === selectedChatId)?.chatList || [];
    return messages.length === 0;
  }
);

export const selectTotalMessageCount = createSelector(
  [selectAllChats],
  (chats) => chats.reduce((sum, chat) => sum + (chat.chatList?.length || 0), 0)
);

export const selectChatsWithMessages = createSelector(
  [selectAllChats],
  (chats) => chats.filter((chat) => chat.chatList?.length > 0)
);

// List of all chats (no transformation needed)
export const selectChatArray = createSelector(
  [selectAllChats],
  (chats) => chats
);

// Get recent chats using recent chat IDs
export const selectChatList = createSelector(
  [selectRecentChatIds, selectAllChats],
  (recentChatIds, chats) =>
    recentChatIds
      .map((chatId) => chats.find((c) => c.chatId === chatId))
      .filter(Boolean)
);
